import styled from "styled-components";

export default styled.hr`
  border-top: 1px dashed rgb(231, 234, 236);
  margin-top: 25px;
  margin-bottom: 25px;
`;
